import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ShiftSection } from './components/ShiftSection';
import { FamiliarSection } from './components/FamiliarSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AuthorSection } from './components/AuthorSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { SiteFooter } from './components/SiteFooter';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
type AppProps = {
  showPurchasePopups?: boolean;
  showFloatingCta?: boolean;
};
export function App({
  showPurchasePopups = true,
  showFloatingCta = true
}: AppProps) {
  return <div className="w-full bg-cream font-sans antialiased" data-id="element-0" data-mp="3mjzuj9tq7c3x">
      <MetaPixel data-id="element-1" data-mp="3rbrbqtqzs5he" />

      <Hero data-id="element-2" data-mp="3rdarmj8qkein" />

      <main data-id="element-3" data-mp="3rcsyvwla8ifh">
        <ProblemSection data-id="element-4" data-mp="3rd189ei755lx" />
        <ShiftSection data-id="element-5" data-mp="5yi8qe3h5da" />
        <FamiliarSection data-id="element-6" data-mp="67z9oh5w26u" />
        <VolumesSection data-id="element-7" data-mp="4n7g6m8exco" />
        <BonusesSection data-id="element-8" data-mp="82jt1oitsae" />
        <OfferSection data-id="element-9" data-mp="2zld0l5ad579f" />
        <GuaranteeSection data-id="element-10" data-mp="2zlv8iz6e19x6" />
        <TestimonialsSection data-id="element-11" data-mp="2zmo5j8fjol24" />
        <AuthorSection data-id="element-12" data-mp="2znfyebhrc4op" />
        <FaqSection data-id="element-13" data-mp="33m5cy7ej7s9x" />
        <FinalCtaSection data-id="element-14" data-mp="33nq55qddiz4m" />
      </main>

      <SiteFooter data-id="element-15" data-mp="33orla998ybt7" />

      {showFloatingCta ? <FloatingCta data-id="element-16" data-mp="38l8f9k34nke7" /> : null}
      {showPurchasePopups ? <PurchasePopup data-id="element-17" data-mp="38nup5qdhqbzl" /> : null}
    </div>;
}